// extracted by mini-css-extract-plugin
export default {"root":"SearchResult_root__ew6FK"};